angular
	.module('mx.components')
	.directive('mxFormErrors', function mxFormErrorsDirective() {
		return {
			restrict: 'E',
			controller: MxFormErrorsCtrl,
			controllerAs: 'vm',
			require: ['?^form', '?^mxForm'],
			scope: {},
			templateUrl: 'mx-form-errors/mx-form-errors.html',
			link: function (scope, element, attrs, ctrls) {
				scope.vm.initialize(ctrls[0], attrs, ctrls[1]);
			},
			bindToController: {
				errors: '=?',
				validationStatus: '&',
			},
		};
	})
	.directive('mxControlErrors', function mxControlErrorsDirective() {
		return {
			restrict: 'E',
			controller: MxControlErrorsCtrl,
			controllerAs: 'vm',
			require: ['?^form', '?^ngModel'],
			scope: {},
			template: (tEl, tAttrs) =>
				'<div ng-show="vm.errorMessages" class="mx-form-validation mx-animate" ng-bind-html="vm.errorMessages" title="{{vm.errorMessages}}" ' +
				(tAttrs.msgElemId ? 'id="{{::vm.msgElemId}}"' : '') +
				'></div>',
			link: function (scope, element, attrs, ctrls) {
				scope.vm.initialize(ctrls[0], ctrls[1], attrs);
			},
			bindToController: {
				options: '=?',
				msgElemId: '@',
			},
		};
	});

MxControlErrorsCtrl.$inject = ['$scope', 'mx.internationalization'];

function MxControlErrorsCtrl($scope, i18n) {
	const vm = this;

	vm.$onInit = function () {
		vm.errorMessages = null;
		vm.internalController = null;
		vm.initialize = initialize;
		if (vm.options) {
			vm.validationStatus = vm.options.validationStatus || null;
		}
	};

	function initialize(formController, errorController, attrs) {
		vm.errorController = errorController;
		vm.formController = formController;

		if (vm.errorController?.$error) {
			$scope.$watchCollection('vm.errorController.$error', vm.render);
		}

		$scope.$watchCollection('vm.errorController.mxErrorMessages', vm.render);

		if (formController && vm.errorController && attrs.trackInternal && attrs.trackInternal !== 'false') {
			vm.internalController = formController[$scope.$parent.vm.internalName];

			if (vm.internalController) {
				vm.internalController.label = vm.errorController.label || vm.internalController.$$scope?.vm?.label || '';
				vm.internalController.isVisible = vm.errorController.isVisible;
				$scope.$watch('vm.internalController.$error', vm.render, true);
			}
		}
	}

	vm.render = function () {
		vm.errorController.mxInvalid = vm.errorController.$invalid || vm.internalController?.$invalid || false;

		if (vm.errorController.mxInvalid) {
			let keys = Object.keys(vm.errorController.$error);

			if (keys.length === 0 && vm.internalController) {
				keys = Object.keys(vm.internalController.$error);
			}

			if (vm.errorController.$$attr.customValidation) {
				const customValidationAttribute = vm.errorController.$$attr.ngModel.split('.').pop();
				if (keys.indexOf(customValidationAttribute) !== -1) {
					keys.splice(keys.indexOf(customValidationAttribute), 1);
					keys.push(customValidationAttribute);
				}
			}

			vm.errorMessages = localizeErrorMessages(keys[0], vm, i18n);
		} else {
			vm.errorMessages = null;
		}

		if (vm.validationStatus) {
			vm.validationStatus(vm.errorController.mxInvalid);
		}

		if (vm.formController && angular.isFunction(vm.formController.update)) {
			vm.formController.update();
		}
	};
}

MxFormErrorsCtrl.$inject = ['$scope', 'mx.internationalization'];

function MxFormErrorsCtrl($scope, i18n) {
	const vm = this;
	let _clientErrors = [];
	let _originErrors = null;
	let _errors = [];
	const _formMessages = [];

	vm.$onInit = function () {
		vm.errorMessage = null;
		vm.initialize = initialize;
		vm.allErrors = [];
		vm.activeErrorIndex = -1;
		vm.nextExists = false;
		vm.prevExists = false;

		Object.defineProperty(vm, 'errors', {
			get: function () {
				return _originErrors;
			},
			set: function (value) {
				_originErrors = value;
				_errors = Array.isArray(_originErrors) && _originErrors.length > 0 ? _originErrors.map(getErrorMessage) : [];
				vm.updateErrors();
			},
		});
	};

	function initialize(formController, attrs, mxFormCtrl) {
		vm.errorController = formController;
		vm.mxFormCtrl = mxFormCtrl;

		if (vm.errorController) {
			vm.errorController.mxErrorMessages = vm.errorController.mxErrorMessages || {};
			vm.errorController.addFormErrorMessage = _addFormErrorMessage;

			if (vm.errorController.$error) {
				vm.errorController.update = vm.render;

				// TODO: Optimize the form's checking on invalidation
				$scope.$watch('vm.errorController.$invalid', vm.render, true);
			}
		}

		if (mxFormCtrl) {
			$scope.$watch('vm.mxFormCtrl.isLoading', _showActiveError);
		}
	}

	function getErrorMessage(value) {
		if (angular.isObject(value)) {
			return new mx.components.Forms.ErrorMessage(value.message, value.active, value.type, value.actionButton, value.transient);
		} else {
			return new mx.components.Forms.ErrorMessage(value);
		}
	}

	function _addFormErrorMessage(formMessage) {
		formMessage.onChange = _onErrorMessageChange;
		_formMessages.push(formMessage);
		vm.updateErrors();
	}

	function _onErrorMessageChange() {
		vm.updateErrors();
	}

	vm.nextError = function () {
		if (vm.activeErrorIndex < vm.allErrors.length - 1) {
			vm.activeErrorIndex++;
			_showActiveError();
		}
	};

	vm.prevError = function () {
		if (vm.activeErrorIndex > 0) {
			vm.activeErrorIndex--;
			_showActiveError();
		}
	};

	vm.render = function () {
		$scope.$evalAsync(function () {
			_clientErrors = [];
			if (vm.errorController.$invalid || vm.allErrors.some((e) => e.isActive && e.type === 'error')) {
				const customErrors = [];
				const keys = Object.keys(vm.errorController.$error).filter((key) => key !== 'customErrors');

				for (let key of keys) {
					const message = localizeErrorMessages(key, vm, i18n);
					const keyErrors = vm.errorController.$error[key];

					for (let item of keyErrors) {
						if (item) {
							const error = getErrorMessage(
								'<div flex layout="column" class="error-message_field-name">' +
									(item.label || '') +
									'</div>' +
									'<div flex layout="column" class="error-message_error-text">' +
									message +
									'</div>'
							);
							if (item.$$attr?.customValidation && item.$$attr.ngModel.split('.').pop() === key) {
								customErrors.push(error);
							} else {
								_clientErrors.push(error);
							}
						}
					}
				}

				Array.prototype.push.apply(_clientErrors, customErrors);
			}

			vm.updateErrors();
		});
	};

	vm.updateErrors = function () {
		let errors = _formMessages.concat(_clientErrors).filter((e) => e.isActive);
		const noFormErrors = !errors.find((e) => e.type === 'error');
		const noCustomErrors = _formMessages.filter((e) => e.type === 'error' && e.isActive).length === 0;

		vm.errorController.$setValidity('customErrors', noCustomErrors);

		vm.validationStatus({ status: noFormErrors });

		if (_errors.length > 0) {
			errors = errors.concat(_errors.filter((e) => e.isActive && e.message));
		}
		vm.allErrors = errors;
		vm.activeErrorIndex = vm.allErrors.length > 0 ? 0 : -1;
		_showActiveError();
	};

	vm.actionButtonClick = function (errorMessage) {
		if (errorMessage.actionButton && angular.isFunction(errorMessage.actionButton.clickHandler)) {
			errorMessage.actionButton.clickHandler();
		}
	};

	function _showActiveError() {
		if (vm.mxFormCtrl?.isLoading) {
			vm.errorMessage = undefined;
			return;
		}

		vm.errorMessage = vm.allErrors[vm.activeErrorIndex];
		const hasErrors = vm.allErrors.some((e) => e.isActive && e.type === 'error' && !e.transient);

		$scope.$evalAsync(function () {
			vm.errorController.$invalid = hasErrors;
		});

		if (typeof vm.errorMessage !== 'undefined') {
			vm.nextExists = vm.activeErrorIndex < vm.allErrors.length - 1;
			vm.prevExists = vm.activeErrorIndex > 0;
		}
	}
}

function MxFormErrorMessage(message, active, type, actionButton, transient) {
	let _isActive = typeof active === 'undefined' || !!active;
	type = type ? type.toLowerCase() : '';

	if (type !== 'warning' && type !== 'info') {
		type = 'error';
	}

	Object.defineProperty(this, 'type', { writable: false, value: type });
	Object.defineProperty(this, 'transient', { writable: true, value: transient });
	Object.defineProperty(this, 'message', { writable: true, value: message });
	Object.defineProperty(this, 'onChange', { writable: true, value: null });
	Object.defineProperty(this, 'isActive', {
		get: function () {
			return _isActive;
		},
		set: function (value) {
			_isActive = value;
			if (typeof this.onChange === 'function') {
				this.onChange(this);
			}
		},
	});

	Object.defineProperty(this, 'actionButton', { writable: false, value: actionButton });
}

function localizeErrorMessages(errorCode, ctrl, i18n) {
	return ctrl.errorController.mxErrorMessages[errorCode] || i18n.getFormatted('components.form-validation.' + errorCode) || '';
}

window.mx = window.mx || {};
window.mx.components = window.mx.components || {};
window.mx.components.Forms = window.mx.components.Forms || {};
window.mx.components.Forms.ErrorMessage = MxFormErrorMessage;
